export const SeriesAlertId = 'alert';
export const SeriesStoplightId = 'stoplight';
export const SeriesPrimaryId = 'primary';
export const SeriesMeasurementId = 'measurement';
export const SeriesMovingAverageId = 'moving_average';
